module.exports = __webpack_public_path__ + "img/deal-handshakes.1968bdd.svg";